import { IComponentOptions } from "angular";
import { MachinesDetailProgressiveMeterReadingsViewController } from "./controller";

export const vsComponentName = "machineDetailProgressiveMeterReadingsComponent";

export const machineDetailProgressiveMeterReadingsComponentOptions: IComponentOptions =
  {
    controller: MachinesDetailProgressiveMeterReadingsViewController,
    controllerAs: "stateController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      machine: "<",
    },
  };
